import React, { PureComponent } from 'react';
import {
	Table,
	Spin,
	Row,
	Col,
	Button,
	Card,
	Typography,
	DatePicker,
	Select,
	Menu,
	Dropdown,
	Icon
} from 'antd';
import { numberWithSpaces } from 'src/components/Table/SearchOnField';
import styles from './styles';
import CONSTANTS from 'src/constants';
import moment from 'moment';

import Search from 'antd/lib/input/Search';
//redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getDetailRestaurantGroup, getRestaurantGroupTransactionByCreditor } from 'src/redux/actions/restaurantGroup.js';
import { getTransactionHistory } from 'src/redux/actions/transactions.js'
import AuthStorage from '../../../../utils/AuthStorage';
import ButtonExportCsvByUrl from 'src/components/Button/ButtonExportCsvByUrl';

const { RangePicker } = DatePicker;
const { Text, Title } = Typography;
const { Option } = Select;

function mapStateToProps(state) {
	return {
		store: {
		}
	};
}

const mapDispatchToProps = dispatch => {
	return {
		action: bindActionCreators(
			{
				getDetailRestaurantGroup,
				getRestaurantGroupTransactionByCreditor,
				getTransactionHistory
			},
			dispatch
		)
	};
};
const now = new Date();
@connect(
	mapStateToProps,
	mapDispatchToProps
)
export default class RestaurantGroupDashboard extends PureComponent {
	state = {
		filterRestaurantData: [],
		dataHistoryEncaissement: [],
		loading: false,
		loadingSelect: false,
		date1: '',
		date2: '',
		detail: [],
		restaurantInGroup: [],
		date1Encaissement: moment(new Date(now.getFullYear(), now.getMonth(), 1), 'DD/MM/YYYY').format('YYYY-MM-DD 00:00:00'),
		date2Encaissement: moment(new Date(now.getFullYear(), now.getMonth() + 1, 0), 'DD/MM/YYYY').format('YYYY-MM-DD 23:59:59'),
		payloadExportEncaissement: {}
	}
	componentDidMount() {
		const { id } = this.props;
		const { idInfo } = AuthStorage;
		this.handleGetRestaurantGroupDetail(idInfo);
	}

	handleGetRestaurantGroupDetail = id => {
		const payload = { id };
		this.setState({ loading: true, loadingSelect: true })
		this.props.action.getDetailRestaurantGroup(
			payload,
			res => {
				this.setState({ loading: false, loadingSelect: false, detail: res, restaurantInGroup: res.restaurants }),
					this.restaurantGroupHistoryEncaissement()
			},
			() => this.setState({ loading: false })
		);
	};

	restaurantGroupHistoryEncaissementOld = (value, date1, date2, search, amount) => {
		const { detail } = this.state;
		this.setState({
			restaurantEncaissement: value
		})
		let payload = {
			pagination: false,
			'date[before]': date2 ? date2 : moment(this.state.date2Encaissement).format('YYYY-MM-DD 23:59:59'),
			'date[after]': date1 ? date1 : moment(this.state.date1Encaissement).format('YYYY-MM-DD 00:00:00'),
		}

		if (search) {
			payload['transactionId'] = search;
		}

		if (amount) {
			payload['amount'] = amount;
		}

		if (detail.restaurants.length > 0) {
			if (value && value.length > 0) {
				value.map((e, key) => {
					payload[['creditor.id[' + key + ']']] = e
				})
				this.setState({ loading: true })
			}
			else {
				detail.restaurants.map((e, key) => {
					payload[['creditor.id[' + key + ']']] = e.user.id
				})
				this.setState({ loading: true })
			}
			this.props.action.getRestaurantGroupTransactionByCreditor(
				payload,
				res => { this.setState({ dataHistoryEncaissement: res['hydra:member'], loading: false, payloadExportEncaissement: payload }) }
			)
		}
	}

	restaurantGroupHistoryEncaissement = (value, date1, date2, search, amount) => {
		const { detail } = this.state;
		this.setState({
			restaurantEncaissement: value
		})
		let payload = {
			'restaurantGroupId': detail.id,
			'dateStart': date1 ? moment(date1).format('YYYY-MM-DD 00:00:00') : moment(this.state.date1Encaissement).format('YYYY-MM-DD 00:00:00'),
			'dateEnd': date2 ? moment(date2).format('YYYY-MM-DD 23:59:59') : moment(this.state.date2Encaissement).format('YYYY-MM-DD 23:59:59'),
		}

		let payloadExportEncaissement = {
			'date[after]': date1 ? moment(date1).format('YYYY-MM-DD 00:00:00') : moment(this.state.date1Encaissement).format('YYYY-MM-DD 00:00:00'),
			'date[before]': date2 ? moment(date2).format('YYYY-MM-DD 23:59:59') : moment(this.state.date2Encaissement).format('YYYY-MM-DD 23:59:59'),
		}

		if (search) {
			payload['search'] = search;
			payloadExportEncaissement['transactionId'] = search;
		}

		if (amount) {
			payload['amount'] = amount;
			payloadExportEncaissement['amount'] = amount;
		}

		if (detail.restaurants.length > 0) {
			if (value && value.length > 0) {
				value.map((e, key) => {
					payload[['restaurantInGroup[' + key + ']']] = e
					payloadExportEncaissement[['creditor.id[' + key + ']']] = e
				})
				this.setState({ loading: true })
			}
			else {
				detail.restaurants.map((e, key) => {
					payload[['restaurantInGroup[' + key + ']']] = e.user.id
					payloadExportEncaissement[['creditor.id[' + key + ']']] = e.user.id
				})
				this.setState({ loading: true })
			}
			this.props.action.getTransactionHistory(
				payload,
				res => { this.setState({ dataHistoryEncaissement: res, loading: false, payloadExportEncaissement: { ...payloadExportEncaissement } }) }
			)
		}

	}

	handleFilterRestaurant = (value) => {
		const { date1, date2 } = this.state;
		this.setState({ filterRestaurantData: value })
		value && value.length > 0 ? this.restaurantGroupHistoryEncaissement(value, date1, date2) : ''
	}

	handleFilterDate = (dataString) => {
		const date1 = dataString && dataString[0] ? moment(dataString[0], 'DD/MM/YYYY').format('YYYY-MM-DD 00:00:00') : null;
		const date2 = dataString && dataString[1] ? moment(dataString[1], 'DD/MM/YYYY').format('YYYY-MM-DD 23:59:59') : null;
		this.setState({ date1: date1, date2: date2, date1Encaissement: date1, date2Encaissement: date2 })
		dataString && dataString.length > 0 ? this.restaurantGroupHistoryEncaissement(this.state.filterRestaurantData, date1, date2) : ''

	}

	render() {
		const dataSource = this.state.restaurantInGroup && this.state.restaurantInGroup.map(d => ({
			...d,
		}));
		const dataHistory = this.state.dataHistoryEncaissement && this.state.dataHistoryEncaissement.map(d => ({
			...d,
		}));

		let totalEncaissement = 0;

		const columns = [
			{
				title: 'Date',
				dataIndex: 'date',
				sorter: (a, b) => b.date.localeCompare(a.date),
				render: (date) => {
					return <Text style={{ fontStyle: 'italic' }}>{moment(date).format('DD-MM-YYYY à H:m:s')}</Text>
				}
			},
			{
				title: 'Etablissement',
				dataIndex: '',
				sorter: (a, b) => {
					let var1 = a.creditorInfo ? a.creditorInfo.creditorName : a.creditorName
					let var2 = b.creditorInfo ? b.creditorInfo.creditorName : b.creditorName
					return var1.localeCompare(var2)
				},
				render: (data) => {
					return (
						data.creditType == "REFUND" || data.creditType == "DEBIT" ?
							<Text>
								{data.debitorInfo && data.debitorInfo.debitorName}
							</Text>
							:
							<Text>
								{data.creditorInfo ? data.creditorInfo.creditorName : data.creditorName}
							</Text>
					)
				}
			},
			{
				title: 'Montant',
				dataIndex: '',
				key: 'amount',
				align: 'right',
				sorter: (a, b) => {
					let val1 = (a.creditType == 'CANCEL') ? a.amount * 0 : (a.creditType == 'PAYMENT' ? a.amount * -1 : ((a.creditType == 'DEBIT' && (a.debitorInfo && (a.debitorInfo.debitorRole == 'ROLE_RESTAURANT')) ? a.amount - 1 : a.amount)));
					let val2 = (b.creditType == 'CANCEL') ? b.amount * 0 : (b.creditType == 'PAYMENT' ? b.amount * -1 : ((b.creditType == 'DEBIT' && (b.debitorInfo && (b.debitorInfo.debitorRole == 'ROLE_RESTAURANT')) ? b.amount - 1 : b.amount)));
					return val1 - val2
				},
				render: (e, opt) => (
					<Text strong style={{
						color: opt.creditType == "PAYMENT" ? '#00c68e' : (opt.creditType == "CANCEL" ? 'orange' : 'red')
					}}>
						{
							`${opt.creditType == "PAYMENT" ? '+' : (opt.creditType == "CANCEL" ? '' : '-')}${numberWithSpaces(e.amount)} ${CONSTANTS.CURRENCY
							}`
						}
					</Text>)
			},
			{
				title: "Référence",
				dataIndex: 'transactionId',
				sorter: (a, b) => b.transactionId.localeCompare(a.transactionId)
			},
			{
				title: 'Note 1',
				dataIndex: 'noteMain',
			},
			{
				title: 'Note 2',
				dataIndex: 'noteSub',
			}
		];

		const menu = (
			<Menu >
				<Menu.Item key="CSV">
					<ButtonExportCsvByUrl url={'/get-export-credit-history-csv'} payload={this.state.payloadExportEncaissement} />
				</Menu.Item>
				{/* <Menu.Item key="PDF">
					<ButtonExportPDF payload={this.props.context.payloadExportEncaissement} />
				</Menu.Item> */}
			</Menu>
		);

		return (
			this.state.detail && (
				<>
					<Card style={{ marginBottom: 10 }}>
						<Card style={{ marginBottom: 10 }}>
							<Row gutter={24}>
								<Col span={4}>
									<Text strong>Filtrer par établissement(s)</Text>
								</Col>
								<Col span={10}>
									{
										(!this.state.loadingSelect) && (
											<Select
												mode="multiple"
												style={{ width: '100%' }}
												placeholder="Selectionnez vos établissements"
												allowClear
												onChange={this.handleFilterRestaurant}
												optionLabelProp="label"
											>
												{
													dataSource.map((prefix, index) => (
														<Option key={index} value={prefix.user.id} label={prefix.restaurantName} style={styles.optionSelectStyle}>
															{prefix.restaurantName}
														</Option>
													)
													)}
											</Select>
										)
									}
								</Col>
							</Row>
						</Card>
						<Card>
							<Row gutter={24}>
								<Col span={4}>
									<Text strong>Filtrer sur une période précise: </Text>
								</Col>
								<Col span={20}>
									<RangePicker
										style={{ width: '500px' }}
										onChange={(e) => this.handleFilterDate(e)}
										value={[moment(new Date(this.state.date1Encaissement), 'DD-MM-YYYY'), moment(new Date(this.state.date2Encaissement), 'DD-MM-YYYY')]}
										format={'DD-MM-YYYY'}
										allowClear={false}
									/>
								</Col>
							</Row>
						</Card>
					</Card>

					<Card style={{ marginBottom: 10 }}>

						<Row type="flex" justify="space-between" align="top" style={{ marginBottom: 10 }}>
							<Col>
								<Title level={4}>Historique des encaissements</Title>
							</Col>
							<Col>
								<Dropdown overlay={menu} trigger={['click']}>
									<Button type="link">
										<Icon type="export" /> Export
									</Button>
								</Dropdown>
							</Col>
						</Row>

						<Row gutter={24} style={{ marginBottom: 10 }}>
							<Col span={12}>
								<Card style={{ boxShadow: '2px 2px 10px lightgrey' }}>
									<Row type="flex" align="middle" justify="space-between">
										<Col>
											<Text strong>Total encaissé :</Text>
										</Col>
										<Col>
											<div style={{ float: 'right', width: '100%' }}>
												<Row>
													<Text style={{
														fontSize: '30px',
														borderRadius: '10px',
														color: '#16C68F',
														fontWeight: 'bold'
													}}>
														{
															dataHistory.forEach(element => {
																element.creditType == "PAYMENT" && (totalEncaissement += element.amount)
															})
														}
														{numberWithSpaces(totalEncaissement) + " "}
														<span style={{ fontSize: '12px', padding: '0 10px' }}>
															{CONSTANTS.CURRENCY}
														</span>
													</Text>
												</Row>
											</div>
										</Col>
									</Row>
								</Card>
							</Col>
						</Row>

						<Row gutter={24} style={{ marginBottom: 20, marginTop: 20 }}>
							<Col span={6}>
								<Search
									allowClear
									placeholder="N° de référence"
									onChange={(e) => this.restaurantGroupHistoryEncaissement(this.state.filterRestaurantData, this.state.date1Encaissement, this.state.date2Encaissement, e.target.value)}
								/>
							</Col>
							<Col span={6}>
								<Search
									allowClear
									placeholder="Montant"
									onChange={(e) => this.restaurantGroupHistoryEncaissement(this.state.filterRestaurantData, this.state.date1Encaissement, this.state.date2Encaissement, null, e.target.value)}
								/>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>

								<Spin spinning={this.state.loading}>
									<Table
										columns={columns}
										scroll={{ y: '65vh', x: '100%' }}
										dataSource={dataHistory}
										rowKey="id"
										pagination={{
											showSizeChanger: true,
											pageSizeOptions: ['100', '500', '1000'],
											defaultPageSize: 100,
											style: { paddingRight: 50 }
										}}
									/>
								</Spin>

							</Col>
						</Row>

					</Card>
				</>
			)
		);
	}
}
